import React, { useState } from "react"

import "./forgotPassword.css"
import logo from "../../../assets/logo-login.svg"
import { Link, useNavigate } from "react-router-dom"
import { forgotPassword } from "../../../services/academetrics"

const ForgotPassword = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [passwordError, setPasswordError] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleForgotPassword = async (e) => {
    e.preventDefault()

    if (password.length <= 7) {
      console.log('SENHA', password)
      setPasswordError("A senha deve ter mais de 8 caracteres.")
      return
    } else {
      setPasswordError("")
    }

    if (email && password) {
      setIsLoading(true)
      try {
        const data = await forgotPassword(email, password)
        navigate("/auth/login")
      } catch (err) {
        console.log('ENTROU NO CATCH')
        console.log(err.message)
        setPasswordError(err.message)
      } finally {
        setIsLoading(false)
      }
    }
  }

  return (
    <form onSubmit={handleForgotPassword} className="login-form">
      <div className="logo-form">
        <img src={logo} alt="Academetrics Logo" className="login-logo" />
      </div>

      <p className="login-describe">
        Preencha os campos abaixo para redefinir uma nova senha
      </p>

      <div className="input-container">
        <span className="input-icon user-icon"></span>
        <input
          type="text"
          placeholder="Usuário"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input-container">
        <span className="input-icon password-icon"></span>
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={passwordError ? "error" : ""}
        />
      </div>

      {passwordError && (
        <p className="error-message">
          <span className="bold-text">Erro: </span> {passwordError}
        </p>
      )}

      <button type="submit" disabled={isLoading}>
        {isLoading ? "Carregando..." : "Atualizar senha"}
      </button>

      <Link to="/auth/login" className="back-to-login">
        ← Voltar para login
      </Link>
    </form>
  )
}

export default ForgotPassword
